import { Box, Paper, Typography } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';
import { FC } from 'react';

interface TestimonialProps {
  content: string;
  rating: number;
}

export const Testimonial: FC<TestimonialProps> = ({ content, rating }) => {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 4,
        height: '100%',
        textAlign: 'center',
        borderRadius: 3,
        bgcolor: 'primary.main',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }}
    >
      <Typography
        variant="body1"
        sx={{
          fontStyle: 'italic',
          mb: 3,
          color: 'primary.contrastText',
        }}
      >
        `{content}`
      </Typography>
      <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
        {[...Array(rating)].map((_, index) => (
          <StarIcon key={index} sx={{ color: 'warning.main' }} />
        ))}
      </Box>
    </Paper>
  );
};
